export const vms_gen32 = [
  { name: "VM01 Zerschneider", location: "Haus des Kapitäns (MS Anne)" },
  { name: "VM02 Fliegen", location: "Route 16 – Haus hinter dem Baum" },
  { name: "VM03 Surfer", location: "Safari-Zone – Geheimer Raum" },
  { name: "VM04 Stärke", location: "Fuchsania City – Safari-Zone Wächter (mit Goldzahn)" },
  { name: "VM05 Blitz", location: "Route 2 – vom Assistent des Professors (mit 10 Pokémon)" },
  { name: "VM06 Zertrümmeer", location: "Gluttherme - Eiland Eins" },
  { name: "VM07 Kaskade", location: "Eiskaskadenhöhle - Eiland Vier" },
];
